import { useEffect } from 'react';
export var useMount = function useMount(mountFn, unMountFn) {
  return useEffect(function () {
    mountFn();
    return unMountFn;
  }, []);
}; // eslint-disable-line

export default useMount;